import styled from 'styled-components'
import theme from 'vars/theme'
import { Button } from 'reactstrap'
import Checkbox from 'components/Checkbox'

export const FormBlockWrapper = styled.div<{ noBorder?: boolean }>`
  padding: 1rem;
  border-bottom: ${({ noBorder }) => (noBorder ? '0px solid' : `1px solid ${theme.grayPrimary}`)};
  margin-bottom: ${(props) => props.hasMarginButton && '70px'};
`

export const CheckboxSpWrapper = styled(Checkbox)`
  display: flex;
  align-items: center;
  height: 30px;

  & input {
    width: 200px;
    height: 30px;
  }

  & .check-icon {
    width: 30px;
    height: 30px;

    img {
      width: 24px !important;
      height: 24px !important;
      margin-top: -5px !important;
    }
  }

  span.text-primary {
    color: ${theme.darkGrayPrimary} !important;
    font-weight: normal !important;
    font-size: 20px;
    margin-left: 42px !important;
  }
`

export const SelectInputWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  .label {
    font-size: 14px;
    line-height: 1.2;
    word-break: break-word;
  }
`

export const RequiredText = styled.span`
  color: ${theme.redPrimary2};
  font-size: 14px;
  width: 60px;
`

export const ButtonWrapper = styled(Button)`
  &:focus {
    box-shadow: none;
  }
`
